<div class="buttons-container">
  <div class="total"> {{ getTitleString() }} </div>
  <a href="{{'shop.webshopLink' | translate }}" target="_blank">
    <button class="button-margin" mat-raised-button color="primary" type="button">
      <mat-icon>shopping_cart</mat-icon> {{'shop.buy' | translate }}
    </button>
  </a>
</div>
